import RawTextField, { RawTextDefaultProps } from './components/RawTextField.js';
import { TextFieldSize } from './constants.js';
import React__default from 'react';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextField = function TextField(_ref) {
  var _ref$isResizeable = _ref.isResizeable,
      isResizeable = _ref$isResizeable === void 0 ? RawTextDefaultProps.isResizeable : _ref$isResizeable,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? RawTextDefaultProps.size : _ref$size,
      _ref$isRounded = _ref.isRounded,
      isRounded = _ref$isRounded === void 0 ? RawTextDefaultProps.isRounded : _ref$isRounded,
      props = _objectWithoutProperties(_ref, ["isResizeable", "size", "isRounded"]);

  return /*#__PURE__*/React__default.createElement(RawTextField, _extends({
    isResizeable: isResizeable,
    size: size,
    isRounded: isRounded
  }, props, {
    type: "text"
  }));
};

TextField.Sizes = TextFieldSize;

export { TextField as default };
